import { render, staticRenderFns } from "./baseList.vue?vue&type=template&id=6d3b6304&"
import script from "./baseList.vue?vue&type=script&lang=js&"
export * from "./baseList.vue?vue&type=script&lang=js&"
import style0 from "./baseList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports